module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head1"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("To the archivists and librarians in Special Collections at the Library of Virginia who helped me track down old photographs for this book from the Visual Studies Collection.")]), _vm._v(" "), _c('li', [_vm._v("To the archivists and librarians in the Manuscripts Room at the Library of Virginia who helped me rummage through dusty executive papers in the State Records Collection.")]), _vm._v(" "), _c('li', [_vm._v("To the archivists and librarians at Local History/Special Collections at the Barrett Branch Library in Alexandria who have provided invaluable advice and support.")]), _vm._v(" "), _c('li', [_vm._v("And to Hope Nelson, my partner in crime and my inspiration.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1789404b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 72
// module chunks = 0